import request from '@/utils/request'

/**
 * 字典管理API模块
 */
const dictApi = {
  /**
   * 分页查询数据字典列表
   */
  querySysDict(data) {
    return request({url: '/service/sysDict/querySysDict',method: 'post',data})
  },
  // 新增数据字典
  addSysDict(data) {
    return request({url: '/service/sysDict/addSysDict',method: 'post',data})
  },
  // 删除数据字典
  delSysDict(id) {
    return request({url: '/service/sysDict/delSysDict?id='+id,method: 'put'})
  },
  // 修改数据字典
  upSysDict(data) {
    return request({url: '/service/sysDict/upSysDict',method: 'post',data})
  },
  // 分页查询数据字典子级列表
  queryDictChild(data) {
    return request({url: '/service/sysDict/queryDictChild',method: 'post',data})
  },
  // 根据上级字典编码查询子集
  queryDictByPCode(pcode) {
    return request({url: '/service/sysDict/queryDictByPCode?pcode='+pcode,method: 'get'})
  },
  // 查询地点信息可用的始发港
  queryStartPlaceOptions() {
    return request({url: '/service/sysDict/queryStartPlaceOptions',method: 'get'})
  },
  // 根据字典编码获取字典值
  getValByCode(code) {
    return request({url: '/service/sysDict/getValByCode?code='+code,method: 'get'})
  },
  // 数据导入
  testBtn() {
    return request({url: '/service/sysDict/testBtn',method: 'get'})
  },
  queryRouteManager(data) {
    return request({ url: '/service/sysDict/queryRouteManager', method: 'post', data })
  },
  queryRouteOptionsByPol(pol) {
    const query = pol ? ('?pol=' + encodeURIComponent(pol)) : ''
    return request({ url: '/service/sysDict/queryRouteOptionsByPol' + query, method: 'get' })
  },
  addRouteManager(data) {
    return request({ url: '/service/sysDict/addRouteManager', method: 'post', data })
  },
  upRouteManager(data) {
    return request({ url: '/service/sysDict/upRouteManager', method: 'post', data })
  },
  addRouteBusiness(data) {
    return request({ url: '/service/sysDict/addRouteBusiness', method: 'post', data })
  },
  saveRouteBusiness(data) {
    return request({ url: '/service/sysDict/saveRouteBusiness', method: 'post', data })
  },
  delRouteManager(id) {
    return request({ url: '/service/sysDict/delRouteManager?id=' + id, method: 'put' })
  },
  delRouteManagerGroup(pol, routeName) {
    return request({ url: '/service/sysDict/delRouteManagerGroup?pol=' + pol + '&routeName=' + encodeURIComponent(routeName), method: 'put' })
  },
  getRouteAdminUsers() {
    return request({ url: '/service/sysDict/getRouteAdminUsers', method: 'get' })
  },
  saveRouteAdminUsers(data) {
    return request({ url: '/service/sysDict/saveRouteAdminUsers', method: 'post', data })
  },
  clearRouteAdminUsers() {
    return request({ url: '/service/sysDict/clearRouteAdminUsers', method: 'put' })
  },
    /**
   * 查询全部箱型最大载重量
   * 返回 key=箱型编码(如40HQ), value=载重量(kg)
   */
  getContainerPayloadMap() {
    return request({ url: '/service/sysDict/getContainerPayloadMap', method: 'get' })
  },
}

export default dictApi